export const RoutesDefinition = {
  landing: process.env.NODE_ENV === 'production' ? '/' : '/',
  root: '/',
  sandbox: '/sandbox',

  survey: '/survey',
  surveyStart: '/survey/start',
  surveyQuestionnaire: '/survey/questionnaire',
  surveySuccess: '/survey/success',
  surveyProcessing: '/survey/processing',
  surveyFail: '/survey/fail',

  account: '/account',
  accountSettings: '/account/settings',
  accountDashboard: '/account/dashboard',
  accountCreate: '/account/create',

  authLogin: '/login',
  logout: '/logout',

  user: '/users',
  resetPassword: '/reset-password',
  resetPasswordSuccess: '/reset-password/success',
  setNewPassword: '/set-new-password',
  verifyEmail: '/verify-email',

  summary: '/summary',
  pending: '/reservation/pending',
  success: '/reservation/success',

  terms: ''
} as const
